import { render, staticRenderFns } from "./CancelPremiumSubs.vue?vue&type=template&id=bb90d5b6&"
import script from "./CancelPremiumSubs.vue?vue&type=script&lang=js&"
export * from "./CancelPremiumSubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports